import { mapState } from 'vuex';

export const site = {
	computed: {
		...mapState({
			siteUrl: (state: any) => state.app.siteUrl,
			csrf: (state: any) => state.app.csrfToken,
			favorites: (state: any) => state.app.favorites,
			subscription: (state: any) => state.commerce.commerceSubscription,
			language: (state: any) => state.app.language,
		}),
	},
};

export const catalog = {
	computed: {
		...mapState({
			filters: (state: any) => state.commerce.commerceFilters,
			sorting: (state: any) => state.commerce.commerceSorting,
		}),
	},
};

export const cart = {
	computed: {
		...mapState({
			cart: (state: any) => state.commerce.commerceCart,
		}),
	},
};
